import { Box, Button, Fade, Modal, Typography } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { TERMS_OF_USE_TEXT } from "../utils/termsOfUseText";

function TermsOfUseModal({ open, onClose, onConfirm }) {
  const [hasReachedBottom, setHasReachedBottom] = useState(false);
  const scrollContainerRef = useRef(null);

  useEffect(() => {
    if (open) {
      setHasReachedBottom(false);
      if (scrollContainerRef.current) {
        scrollContainerRef.current.scrollTop = 0;
      }
    }
  }, [open]);

  const handleScroll = (event) => {
    const { scrollTop, clientHeight, scrollHeight } = event.currentTarget;
    const isAtBottom = scrollTop + clientHeight >= scrollHeight - 8;

    if (isAtBottom) {
      setHasReachedBottom(true);
    }
  };

  return (
    <Modal open={open} onClose={onClose} closeAfterTransition>
      <Fade in={open}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: { xs: "92%", md: 900 },
            bgcolor: "background.paper",
            borderRadius: 2,
            boxShadow: 24,
            p: 3,
          }}
        >
          <Typography variant="h6" sx={{ mb: 2 }}>
            Termos de Uso
          </Typography>

          <Box
            ref={scrollContainerRef}
            onScroll={handleScroll}
            sx={{
              maxHeight: "55vh",
              overflowY: "auto",
              p: 2,
              border: "1px solid",
              borderColor: "divider",
              borderRadius: 1,
              whiteSpace: "pre-line",
              fontSize: "0.95rem",
              lineHeight: 1.6,
            }}
          >
            {TERMS_OF_USE_TEXT}
          </Box>

          <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
            Role ate o final dos termos para habilitar a confirmacao.
          </Typography>

          <Box sx={{ mt: 3, display: "flex", justifyContent: "flex-end", gap: 2 }}>
            <Button variant="outlined" onClick={onClose}>
              Fechar
            </Button>
            <Button
              variant="contained"
              onClick={onConfirm}
              disabled={!hasReachedBottom}
            >
              Confirmo que li
            </Button>
          </Box>
        </Box>
      </Fade>
    </Modal>
  );
}

export default TermsOfUseModal;